import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { MORE_768_MEDIA_QUERY } from '../../../../../consts/adaptive';
import { cssToObject } from '../../../../../../utils/cssToObject';
import { STATIC_HOST_NAME } from '../../../../../../consts/hosts';

export const styles = {
  roomPlaceholderImage: {
    width: '100%',
    height: '240px',
    backgroundImage: `url(\'https://${STATIC_HOST_NAME}/images/placeholder/room/placeholderNoRoomPhoto.jpg\')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: defaultTheme.theme.borderRadiusVariables.main,
    backgroundPosition: 'center',
    marginBottom: '1.5rem',
  },

  sliderWrapper: {
    position: 'relative',
    overflow: 'hidden',
    flex: '0 0 auto',
    marginBottom: '1.5rem',
    width: '100%',
    height: '240px',
    paddingTop: 0,
  },

  swiper: {
    width: '100%',
    height: '100%',
    borderRadius: defaultTheme.theme.borderRadiusVariables.main,
  },

  sliderBullets: {
    width: 'auto',
    height: '4px',
    display: 'block',
    borderRadius: 2,
    border: 'none',
    cursor: 'pointer',
    flex: '1 1 auto',
    opacity: '1',
    background: defaultTheme.theme.colorVariables.bgPrimary,
    transition: 'all 300ms ease-in-out',
    position: 'relative',

    '&:hover': {
      backgroundColor: defaultTheme.theme.colorVariables.bgPrimary,
    },

    '.swiper-container-horizontal>.swiper-pagination-bullets &': {
      margin: '0 0.125rem',
    }
  },

  activeSliderBullets: {
    width: 'auto',
    height: '4px',
    display: 'block',
    borderRadius: 2,
    border: 'none',
    cursor: 'pointer',
    flex: '1 1 auto',
    background: 'rgba(255, 255, 255, 0.5)',

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 0,
      height: '4px',
      borderRadius: 2,
      background: defaultTheme.theme.colorVariables.bgPrimary,
      animation: 'riseWidth 0.3s linear',
      animationFillMode: 'forwards',
    },

    '& ~ button ': {
      background: 'rgba(255, 255, 255, 0.5)',
    },
  },

  randomTag: {
    ...cssToObject(defaultTheme.theme.mixin.fontCaptionM_Caps),
    position: 'absolute',
    left: 0,
    top: 0,
    padding: '0.5rem 1rem',
    zIndex: 10,
    color: defaultTheme.theme.colorVariables.textLight,
    background: defaultTheme.theme.colorVariables.iconPrimary,
    borderRadius: [defaultTheme.theme.borderRadiusVariables.main, 0, defaultTheme.theme.borderRadiusVariables.main, 0],
    boxShadow: defaultTheme.theme.shadowVariables.componentContainer,
  },

  swiperPagination: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    width: '100%',
    margin: 0,
    boxSizing: 'border-box',

    '&.swiper-pagination.swiper-pagination-bullets': {
      padding: '0 1rem',
      bottom: 12,
      width: 'inherit',
    },
  },

  sliderNavButtonPrev: {
    opacity: '0.8',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    top: '40%',
    height: 40,
    padding: '0 1rem 0',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    zIndex: 10,
    left: 0,
    transform: 'rotate(180deg)',

    '&:hover': {
      opacity: 1
    }
  },

  sliderNavButtonNext: {
    opacity: '0.8',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    top: '40%',
    height: 40,
    padding: '0 1rem 0',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    zIndex: 10,
    right: 0,

    '&:hover': {
      opacity: 1
    }
  },

  [MORE_768_MEDIA_QUERY]: {
    sliderWrapper: {
      width: 'calc(50% - 0.75rem)',
      marginRight: '1.5rem',
      marginBottom: 0,
    },

    roomPlaceholderImage: {
      width: 'calc(50% - 0.75rem)',
      marginRight: '1.5rem',
      marginBottom: 0,
    }
  }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
